export default __webpack_public_path__ + "static/media/alphies-random.21e7d481.gif";